import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { CommonModule, AsyncPipe } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { AuthService } from "../../../../services/auth.service";
import { UserService } from '../../../../services/user.service';
import { EncryptionService } from '../../../../services/encryption.service';
import { FormsModule, FormBuilder, FormGroup, ReactiveFormsModule, Validators, AbstractControl } from '@angular/forms';

import validateForm from '../../../../helpers/validateform';
import { MenuService } from '../../../../services/menu.service';

declare var bootstrap: any; // 👈 allow Bootstrap JS API usage

@Component({
  selector: 'app-leftnav',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, AsyncPipe],
  templateUrl: './leftnav.component.html',
  styleUrl: './leftnav.component.css'
})
  
export class LeftnavComponent implements OnInit {
  @ViewChild('btncngPassword') cngButton!: ElementRef;
  @ViewChild('btncngEmail') cngEmailButton!: ElementRef;

  frmChangeEmailNav!: FormGroup;
  frmChangePasswordNav!: FormGroup;
  userRole: any;
  userType: any;
  adminLevel: any;  // Added: AdminLevel
  home: any;
  timeSheet: any;
  timeSheetType: any;
  management: any;
  contract: any;
  notification: any;
  approveAll: any;
  approveAllType: any;
  adminHome: any;
  adminHomeType: any;
  adminManagement: any;
  adminOrderList: any;
  
  repTimeSheet: any;
  repTimeSheetType: any;
  repApproveAll: any;
  repApproveAllType: any;
  repHome: any;
  repHomeType: any;
  repManagement: any;
  managerHome: any;
  managerHomeType: any;
  managerManagement: any;
  managerTimeSheet: any;
  managerTimeSheetType: any;
  managerApproveAll: any;
  managerApproveAllType: any;

  managePassword: any;
  manageEmail: any;
  repId: string = '';

  qa: any;
  qarep: any;

  type: string = "password";
  submitted: boolean = false;
  errorMessage: any;
  successMessage: any;
  constructor(private auth: AuthService, private user: UserService, private formBuilder: FormBuilder, public menuService: MenuService, private en: EncryptionService, private router: Router, private translate: TranslateService,) { }
  
  ngOnInit() {
    this.userRole = this.auth.getRole();
    this.userType = this.auth.getType();
    this.adminLevel = this.auth.getAdminLevel();  // Added: Get AdminLevel
    this.repId = this.auth.getRepId();
    // console.log(this.adminLevel);
    
    // Staff/Clientは従来通り
    this.home = ["Staff"];
    this.timeSheet = ["Client", "Rep"]; // UserRoleは "Staff", "Client", "Rep" のみ存在（"Admin", "Manager" は存在しない）
    this.timeSheetType = ["B", "D", "E"];
    // this.management = [];
    this.contract = ["Client"];
    this.notification = ["Client"];
    this.approveAll = ["Client", "Rep"]; // UserRoleは "Staff", "Client", "Rep" のみ存在（"Admin", "Manager" は存在しない）
    this.approveAllType = ["B", "D", "E"];  // associate-approve-all (Approverあり)
    
    // Admin/Rep/Managerロールの共通タブ定義
    // 注意: UserRoleには "Admin", "Manager" は存在しない（AdminLevel > 0 の場合すべて "Rep" として扱われる）
    // 実際の制御は UserType と AdminLevel で行う
    this.adminManagement = ["Rep"];  // asc-reportは全UserTypeで表示（UserRoleは "Rep" のみ）
    // this.adminHome = ["Admin"];  // "Admin" は存在しないUserRole
    this.adminHomeType = ["C", "D"]; 

    // UserTypeに応じたタブ表示条件
    // this.repTimeSheet = ["Admin", "Rep", "Manager"];  // "Admin", "Manager" は存在しないUserRole（timeSheet配列で制御）
    this.repTimeSheetType = ["B", "D"];  // client-associatelist (Approverあり)
    // this.repApproveAll = ["Admin", "Rep", "Manager"];  // "Admin", "Manager" は存在しないUserRole（approveAll配列で制御）
    this.repApproveAllType = ["B", "D"];  // associate-approve-all (Approverあり)
    this.repHome = ["Rep"];  // "Manager" は存在しないUserRole（UserRoleは "Rep" のみ）
    this.repHomeType = ["C", "D"];  // manager-home (Managerあり)
    // this.repManagement = ["Admin", "Rep", "Manager"];  // adminManagement配列で制御
    
    // this.managerHome = ["Admin", "Rep", "Manager"];  // repHome配列で制御
    this.managerHomeType = ["C", "D"];  // manager-home (Managerあり)
    // this.managerTimeSheet = ["Admin", "Rep", "Manager"];  // timeSheet配列で制御
    this.managerTimeSheetType = ["B", "D"];  // client-associatelist (Approverあり)
    // this.managerManagement = ["Admin", "Rep", "Manager"];  // adminManagement配列で制御
    // this.managerApproveAll = ["Admin", "Rep", "Manager"];  // approveAll配列で制御
    this.managerApproveAllType = ["B", "D"];  // associate-approve-all (Approverあり)
    
    this.manageEmail = ['Staff', 'Client'];
    this.managePassword = ['Staff', 'Client'];

    this.qa = ['Staff', 'Client'];
    this.qarep = ['Rep'];

    const emailPattern = /^(?!.*\.\.)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/;

    this.frmChangePasswordNav = this.formBuilder.group(
      {
        password: ['', Validators.required],
        newPassword: ['', Validators.required],
        retypePassword: ['', Validators.required]
      },
      { validator: this.passwordMatchValidator }
    );
    this.frmChangeEmailNav = this.formBuilder.group(
          {
            registeredEmail: [''],
            notificationEmail: ['', [Validators.required, Validators.pattern(emailPattern)]],
            retypeNotificationEmail: ['', Validators.required]
          },
          { validator: this.emailMatchValidator }
        );
  }
  triggerClick() {
    this.cngButton.nativeElement.click();
  }
  triggerEmailClick() {
    this.cngEmailButton.nativeElement.click();
  }

  passwordMatchValidator(control: AbstractControl): null {
    const newPass = control.get('newPassword');
    const retypePass = control.get('retypePassword');

    if (!newPass || !retypePass) return null;

    const password = newPass.value;
    const confirm = retypePass.value;

    const alphaNumRegex = /^(?=.*[A-Za-z])(?=.*\d).*$/;

    let newPassErrors = newPass.errors || {};
    let retypeErrors = retypePass.errors || {};

    /* -----------------------------------
      NEW PASSWORD VALIDATION
    ------------------------------------ */

    // If required error exists → skip custom validation
    if (newPassErrors['required']) {
      newPass.setErrors({ required: true });
      return null;
    }

    // MIN LENGTH
    if (!password || password.length < 6 || password.length >50) {
      newPassErrors['minlength'] = true;
    } else {
      delete newPassErrors['minlength'];
    }

    // ALPHANUMERIC
    if (!alphaNumRegex.test(password)) {
      newPassErrors['alphanumeric'] = true;
    } else {
      delete newPassErrors['alphanumeric'];
    }

    // Apply updated errors
    newPass.setErrors(Object.keys(newPassErrors).length ? newPassErrors : null);

    /* -----------------------------------
      RETYPE PASSWORD VALIDATION
    ------------------------------------ */

    // Skip match validation if required
    if (retypeErrors['required']) {
      retypePass.setErrors({ required: true });
      return null;
    }

    // MATCH CHECK
    if (password && confirm && password !== confirm) {
      retypeErrors['mismatch'] = true;
    } else {
      delete retypeErrors['mismatch'];
    }

    // Apply updated errors
    retypePass.setErrors(Object.keys(retypeErrors).length ? retypeErrors : null);

    return null;
  }
  
  
  emailMatchValidator(control: AbstractControl): null {
    const orgEmail = control.get('registeredEmail');
    const email = control.get('notificationEmail');
    const retype = control.get('retypeNotificationEmail');

    if (!email || !retype) return null;

    const orgEmailVal = orgEmail ? orgEmail.value : null;
    const emailVal = email.value;
    const retypeVal = retype.value;
    if (orgEmailVal) { 

      if (orgEmailVal === emailVal) {
        // console.log("same")
        email.setErrors({ ...email.errors, samemail: true });  
      } else {
        if (email.errors) {
          delete email.errors['samemail'];
          if (Object.keys(email.errors).length === 0) {
            email.setErrors(null);
          }
        } 
      }
    }

    // Do not run match check if required already failed
    if (retype.errors && retype.errors['required']) return null;

    // Apply mismatch
    if (emailVal && retypeVal && emailVal !== retypeVal) {
      retype.setErrors({ ...retype.errors, mismatch: true });
    } else {
      if (retype.errors) {
        delete retype.errors['mismatch'];
        if (Object.keys(retype.errors).length === 0) {
          retype.setErrors(null);
        }
      }
    }
    return null;
  }

  changePassword() {
      
      // this.submitted = true; 
      if (this.frmChangePasswordNav.invalid) {
        validateForm.validateAllFormFields(this.frmChangePasswordNav);
        alert(this.translate.instant('PleaseFillFormCorrectly'));     
        return;
      }    
      // console.log(this.frmChangePasswordNav.value);
      
      this.frmChangePasswordNav.value.password = this.en.encryptUsingAES256(this.frmChangePasswordNav.value.password);
      this.frmChangePasswordNav.value.newPassword = this.en.encryptUsingAES256(this.frmChangePasswordNav.value.newPassword);
      this.frmChangePasswordNav.value.retypePassword = this.en.encryptUsingAES256(this.frmChangePasswordNav.value.retypePassword);
      
      this.user.changePassword(this.frmChangePasswordNav.value)
        .subscribe({
            next: (res:any) => {
              // alert(res.message);
              if (res.status) {              
                this.errorMessage = '';
                this.successMessage = res.message;
                this.frmChangePasswordNav.reset();
                
                // modalInstance.hide();
                // document.getElementById("cngPassword")?.click();
                this.triggerClick();
                alert(res.message); 
                // Force re-authentication after password change.
                this.logout();
                return;
              } else {
                this.errorMessage = res.message;
                // modalInstance.hide();
                // this.triggerClick();
                alert(res.message);
                if(res.data == 2)
                  this.frmChangePasswordNav.patchValue({ password: '' });
                if(res.data == 3)
                  this.frmChangePasswordNav.patchValue({ newPassword: '', retypePassword: '' });
                if (res.data == 0)
                  this.frmChangePasswordNav.patchValue({ newPassword: '', retypePassword: '' });
              }
              this.submitted = false;
            },
            error: (err: any) => {
              if (err.status == 401) {
                this.logout();
                return
              }
                alert(err.error.message);        
                this.successMessage = '';
                this.errorMessage = err?.error.message;
            }
          });
  }
  
  genEmailPop() {
    this.user.getUserProfile().subscribe({
      next: (res: any) => { 
        if (res.status) {
          // this.auth.storeEmail(res.data.email2);
          // this.frmChangeEmail.value.registeredEmail = 'aa@aa.com';//res.data.email2;
          this.frmChangeEmailNav.patchValue({
            registeredEmail: res.data.email2
          });
          const modalEl = document.getElementById('cngEmailNav');
          const modal = new bootstrap.Modal(modalEl);
          modal.show();
          // console.log(res.data.email2)
        } 
      },
      error: (err: any) => {
        if (err.status == 401) {
          this.logout();
          return
        }
        alert("Something went wrong. Please try again")
      }
    })
  }

  changeEmail() {      
      this.submitted = true; 
      if (this.frmChangeEmailNav.invalid) {
        validateForm.validateAllFormFields(this.frmChangeEmailNav);
        // this.frmChangeEmailNav.markAllAsTouched(); 
        alert(this.translate.instant('PleaseFillFormCorrectly'));     
        return;
      }    
    const newMail = this.frmChangeEmailNav.value.notificationEmail;
    const confirmMsg = this.translate.instant(
    'CONFIRM_CHANGE_EMAIL',
    { email: newMail }
  );
     const confirmed = confirm(confirmMsg);

    if (!confirmed) {
      this.submitted = false;
      return;
    }
      // const modalElement = document.getElementById('cngEmail');
      // const modalInstance = bootstrap.Modal.getInstance(modalElement) 
      //   || new bootstrap.Modal(modalElement);
      // console.log(this.frmChangeEmail.value);
      // return
      this.user.changeEmail(this.frmChangeEmailNav.value)
        .subscribe({
            next: (res:any) => {
              // alert(res.message);
              if (res.status) {              
                this.errorMessage = '';
                this.successMessage = res.message;
                this.frmChangeEmailNav.reset();
                // this.frmChangeEmail.patchValue({ registeredEmail: newMail });
                // this.auth.storeEmail(newMail);
                // modalInstance.hide();
                // document.getElementById("btncngEmail")?.click();
                this.triggerEmailClick();
                alert(res.message);   
              } else {
                this.errorMessage = res.message;
                // modalInstance.hide();
                // document.getElementById("btncngEmail")?.click();
                // this.triggerEmailClick();
                alert(res.message);              
              }
              this.submitted = false;
            },
            error: (err: any) => {
              if (err.status == 401) {
                this.logout();
                return;
              }
                alert(err.error.message);        
                this.successMessage = '';
                this.errorMessage = err?.error.message;
            }
          });
  }
  
  logout() {
    this.auth.logout();
  }

  isActive(url: string) {
    return this.router.url === url;
  }
}